import { css } from '@spectrum-web-components/base';
const styles = css`
    :host{display:table-header-group}:host .spectrum-Table-scroller{z-index:1;position:sticky;inset-block-start:0}
`;
export default styles;